import { render, staticRenderFns } from "./recipeItemCreateModal.vue?vue&type=template&id=31def943&"
import script from "./recipeItemCreateModal.vue?vue&type=script&lang=ts&"
export * from "./recipeItemCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports